import React from 'react'

const Trash = ({ color }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0658 2.19452H11.1699V1.84932C11.1699 0.838356 10.3315 0 9.32055 0H6.80548C5.79452 0 4.95616 0.838356 4.95616 1.84932V2.19452H0.863014C0.394521 2.19452 0 2.58904 0 3.05753C0 3.52603 0.394521 3.92055 0.863014 3.92055H1.87397V15.6575C1.87397 16.9397 2.93425 18 4.21644 18H11.9342C13.2164 18 14.2767 16.9397 14.2767 15.6575V3.92055H15.0904C15.5589 3.92055 15.9534 3.52603 15.9534 3.05753C15.9534 2.58904 15.5589 2.19452 15.0658 2.19452ZM6.68219 1.84932C6.68219 1.77534 6.73151 1.72603 6.80548 1.72603H9.34521C9.41918 1.72603 9.46849 1.77534 9.46849 1.84932V2.19452H6.68219V1.84932ZM12.5507 15.6575C12.5507 16.0027 12.2795 16.274 11.9342 16.274H4.19178C3.84658 16.274 3.57534 16.0027 3.57534 15.6575V3.92055H12.526V15.6575H12.5507Z"
        fill={color}
      />
      <path
        d="M5.42454 14.9426C5.89303 14.9426 6.28755 14.5481 6.28755 14.0796V6.09055C6.28755 5.62206 5.89303 5.22754 5.42454 5.22754C4.95604 5.22754 4.56152 5.62206 4.56152 6.09055V14.0796C4.56152 14.5727 4.93139 14.9426 5.42454 14.9426Z"
        fill={color}
      />
      <path
        d="M10.7507 14.9426C11.2192 14.9426 11.6137 14.5481 11.6137 14.0796V6.09055C11.6137 5.62206 11.2192 5.22754 10.7507 5.22754C10.2822 5.22754 9.8877 5.62206 9.8877 6.09055V14.0796C9.8877 14.5727 10.2822 14.9426 10.7507 14.9426Z"
        fill={color}
      />
      <path
        d="M8.06321 14.9426C8.5317 14.9426 8.92622 14.5481 8.92622 14.0796V6.09055C8.92622 5.62206 8.5317 5.22754 8.06321 5.22754C7.59472 5.22754 7.2002 5.62206 7.2002 6.09055V14.0796C7.2002 14.5727 7.59472 14.9426 8.06321 14.9426Z"
        fill={color}
      />
    </svg>
  )
}

export default Trash
